import { Col, Container, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../../common/integrations'
import { CustomContactAdminSettings } from './CustomContactAdminSettings'
import { useCallback, useMemo, useState } from 'react'
import { SelectContactTypeSection } from './SelectContactTypeSection'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { MappingType } from '../../../../../../../models/Account'
import { PredefinedContactAdminSettings } from './PredefinedContactAdminSettings'
import { useGetIntegrationAdminSettings } from '../../../hook'
import { IntegrationMappingTesterAccordion } from '../../../../TesterTool/TesterAccordion'
import { ContactMappingTester } from '../../../../TesterTool/Contact/ContactMappingTester'
import { ContactSyncMappingTester } from '../../../../TesterTool/Contact/ContactSyncMappingTester'

export interface ContactAdminSettingsProps {
  serviceId: IntegrationServiceId
  disabled?: boolean
}

export const ContactAdminSettings: React.FC<ContactAdminSettingsProps> = ({ serviceId, disabled }) => {
  const [formKey, setFormKey] = useState<number>(0)
  const { watch } = useFormContext<IntegrationSettings>()
  const currentMappingType = watch('mappings.contact.mappingType')

  const isCustom = useMemo(() => currentMappingType === MappingType.CUSTOM, [currentMappingType])

  const refreshForm = useCallback(() => {
    setFormKey((prevKey) => prevKey + 1)
  }, [])

  const { isAccountLoading } = useGetIntegrationAdminSettings(serviceId)

  if (isAccountLoading) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <Container className='py-3'>
      <Row className='mb-3'>
        <Col>
          <h3 className='mb-2'>Contact</h3>
          <div className='zocks-text-gray-600'>
            Configure which {getIntegrationDisplayName(serviceId)} object type and fields to use for contacts, giving you complete flexibility to mirror your
            CRM's workflow in Zocks.
          </div>
        </Col>
      </Row>
      <Row>
        <SelectContactTypeSection onChange={refreshForm} serviceId={serviceId} disabled={disabled} />
      </Row>
      {isCustom ? (
        <>
          <Row>
            <CustomContactAdminSettings serviceId={serviceId} formKey={formKey} />
          </Row>
          <Row className='mt-6'>
            <IntegrationMappingTesterAccordion
              serviceId={serviceId}
              testerComponents={[ContactMappingTester, ContactSyncMappingTester]}
              title='Test Contact Mapping'
            />
          </Row>
        </>
      ) : (
        <Row>
          <PredefinedContactAdminSettings serviceId={serviceId} key={formKey} disabled={disabled} />
        </Row>
      )}
    </Container>
  )
}
